export default "__VITE_ASSET__DdPrih1l__"